/**
 * Date helpers for display and calendar navigation only (YYYY-MM-DD strings, noon UTC so time zones never
 * shift a day). Valid dates, stays and availability always come from the API (invariant 1).
 */

export function addDays(iso, n) {
	const d = new Date(iso + 'T12:00:00Z');
	d.setUTCDate(d.getUTCDate() + n);
	return d.toISOString().slice(0, 10);
}

/** First day of the month n months after the month of iso. */
export function addMonths(iso, n) {
	const [y, m] = iso.split('-').map(Number);
	return new Date(Date.UTC(y, m - 1 + n, 1)).toISOString().slice(0, 10);
}

/** Same day of the month n months later, clamped to the month's last day (PageUp / PageDown). */
export function shiftMonths(iso, n) {
	const [y, m, d] = iso.split('-').map(Number);
	const last = new Date(Date.UTC(y, m - 1 + n + 1, 0)).getUTCDate();
	return new Date(Date.UTC(y, m - 1 + n, Math.min(d, last))).toISOString().slice(0, 10);
}

export function nightsBetween(a, b) {
	return Math.round((Date.parse(b + 'T12:00:00Z') - Date.parse(a + 'T12:00:00Z')) / 86400000);
}

/** 0 = Monday … 6 = Sunday. */
export function weekday(iso) {
	return (new Date(iso + 'T12:00:00Z').getUTCDay() + 6) % 7;
}

export function daysInMonth(month) {
	const [y, m] = month.split('-').map(Number);
	return new Date(Date.UTC(y, m, 0)).getUTCDate();
}

/** "2027-03" for any date of March 2027. */
export const monthOf = (iso) => iso.slice(0, 7);

/** A month "YYYY-MM" (01–12): the shortcode attribute `start` (0.9.5). */
export function isMonth(value) {
	return typeof value === 'string' && /^\d{4}-(0[1-9]|1[0-2])$/.test(value);
}

export function isDate(value) {
	return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value + 'T12:00:00Z'));
}

/**
 * Two-letter weekday names, Monday first, from Intl in the page language (0.9.2: a translated label gave
 * « luo la mia… » in Italian). Display only.
 * @param {string} lang
 * @returns {string[]}
 */
export function weekdayInitials(lang) {
	const format = new Intl.DateTimeFormat(lang, { weekday: 'short', timeZone: 'UTC' });
	return Array.from({ length: 7 }, (_, i) => format.format(new Date(Date.UTC(2027, 2, 1 + i, 12))).replace(/\.$/, '').slice(0, 2));
}
